import React from "react";
import { TrainingTopic } from "../../types/TrainingTopic";
import VideoPlayer from "../VideoPlayer";
import TrainingAssessment from "./TrainingAssessment";
import DocumentPreview from "../DocumentPreview";

interface IProps {
  topic: TrainingTopic;
  nextTopic: () => void;
  updateTopic: (score: number) => void;
  submitAssessment: (score: number) => void;
  updateVideoStatus?: (time: number) => void;
}
export default function TrainingPlayer(props: IProps) {
  const { topic, nextTopic, updateTopic, submitAssessment, updateVideoStatus } = props;

  function saveDocumentAgreement() {
    nextTopic();
  }
  function submitAssessmentScore(score: number) {
    submitAssessment(score);
  }

  function getPlayer() {
    switch (topic.contentType) {
      case "VIDEO":
        return (
          <VideoPlayer
            source={topic.contentPath}
            onEnded={nextTopic}
            onUpdate={updateVideoStatus}
            startTime={topic.status?.currentTime || 0}
          />
        );
      case "DOCUMENT":
        return (
          <DocumentPreview
            documentId={topic.contentPath}
            preview={false}
            onContinue={saveDocumentAgreement}
          />
        );
      case "ASSESSMENT":
        return (
          <TrainingAssessment
            updateTopic={updateTopic}
            topic={topic}
            onContinue={submitAssessmentScore}
          />
        );
      default:
        return null;
    }
  }

  return <>{getPlayer()}</>;
}
